<template>
  <div class="feedBack_add_dialog">
    <custom-dialog width="900px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <div class="title" style="margin: 0 0 24px">{{ $t('asm_feedBack_add_dialog.xuan_ze_ling_jian') }}</div>
          <!-- :column="tableColumn" -->
          <custom-table
            height="300px"
            :index="true"
            type="radio"
            v-model="form.selectRow"
            :data="tableList"
            tableCode="feedBack_part"
            @sort="sortChange"
            @filter="filterChange"
            @change="onChange"
          ></custom-table>
          <div class="base-item">
            <div class="base-item">
              <div class="title" style="margin-top: 24px">{{ $t('asm_feedBack_add_dialog.ling_jian_xin_xi') }}</div>
              <div class="row">
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jian_lei_bie') }}</div>
                  <div class="val">{{ getDicValue('asm_part_class', form.selectRow.partClass) }}</div>
                </div>
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jian_lei_xing') }}</div>
                  <div class="val">{{ getDicValue('asm_part_type', form.selectRow.partType) }}</div>
                </div>
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jian_bian_hao') }}</div>
                  <div class="val">{{ form.selectRow.partCode }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jian_ming_cheng') }}</div>
                  <div class="val">{{ form.selectRow.partName }}</div>
                </div>
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jianSN') }}</div>
                  <div class="val">{{ form.selectRow.partSn }}</div>
                </div>
                <div class="col">
                  <div class="key">{{ $t('asm_feedBack_add_dialog.ling_jian_shu_liang') }}</div>
                  <div class="val">{{ form.selectRow.replaceNum }}</div>
                </div>
              </div>
            </div>
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('asm_feedBack_add_dialog.shi_fou_jin_shui')" prop="isSoak" :rules="rules.isSoak">
                <custom-select v-model="form.isSoak" code="isynergy_cloud_bool" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('asm_feedBack_add_dialog.gu_zhang_miao_shu')" prop="feedBackDesc" :rules="rules.feedBackDesc">
                <el-input type="textarea" :rows="3" v-model="form.feedBackDesc" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(0)">{{ $t('Common.com_save') }}</el-button>
        <el-button size="small" type="primary" @click="confirm(1)">{{ $t('Common.com_submit') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      tableList: [],
      fileList: [],
      form: {
        workOrderId: '',
        orderPartId: '',
        partId: '',
        partCode: '',
        partName: '',
        partClass: '',
        partType: '',
        partSpec: '',
        partUnit: '',
        replaceNum: '',
        isSoak: '0',
        partSn: '',
        feedBackDesc: '',
        picList: [],
        selectRow: {},
        isSubmit: 0,
        changeId: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        isSoak: [
          {
            required: true,
            message: this.$t('asm_feedBack_add_dialog.qxzsfjs'),
            //
          },
        ],
        feedBackDesc: [
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
          {
            required: true,
            message: this.$t('asm_feedBack_add_dialog.qtxgzms'),
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type === 'add') {
        this.form.workOrderId = this.model.data.workOrderId;
        this.getTableList();
        // this.item = this.model.data;
        // this.getDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    getTableList: function () {
      this.$getJSON(apis.workOrderPartList, {
        workOrderId: this.model.data.workOrderId,
        // orderTechnicianId: this.model.data.orderTechnicianId,
      }).then((res) => {
        this.tableList = res.data || [];
      });
    },
    getDetail: function () {
      this.$getJSON(apis.PartInfo, { partId: this.model.data.partId }).then((res) => {
        const item = Object.assign({}, res.data);
        item.applyProduct = item.applyProduct ? item.applyProduct.split(',') : '';
        this.fileList = item.picList;
        this.item = item;
        this.$setFormatData(this.form, this.item);
        this.form.currencyUnit = this.item.currencyUnit || '¥';
      });
    },
    onPartCodeChange: function (item) {
      if (item) {
        this.form.partName = item.partName;
        this.form.partClass = item.partClass;
        this.form.partType = item.partType;
        this.form.partSpec = item.partSpec;
        this.form.partUnit = item.partUnit;
      }
    },
    onChange: function (item) {
      // 获取零件变更图片
      if (!item) {
        return;
      }
      if (item.beforeReplaceImg) {
        this.$getJSON(apis.attachList, {
          attachIds: item.beforeReplaceImg,
        }).then((res) => {
          this.form.picList = res.data;
        });
      }
    },
    // 确认保存
    confirm: async function (isSubmit) {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (Object.keys(this.form.selectRow).length === 0) {
          this.$message({
            message: this.$t('asm_feedBack_add_dialog.qxxzyxzlfklj'),
            type: 'error',
          });
        }
        // 零件更换日期已超出服务期限，无法申请质量反馈。 业务状态是已购机
        if (!this.$moment(this.model.data.rentalEndTime).isAfter(this.form.selectRow.replaceTime) && `${this.model.data.bizState}` === '52') {
          this.$message({
            message: this.$t('asm_feedBack_add_dialog.ljghrqyccfqxwfsqzlfk'),
            type: 'error',
          });
        } else {
          this.$postJSON(`${apis.feedbackIsRepeatApply}/${this.form.selectRow.orderPartId}`, null, true).then((res) => {
            if (res.data) {
              const tips = this.$t('asm_feedBack_add_dialog.gljysqgzlfknqdycftjm');
              this.$showConfirm(tips).then(() => {
                this.form = {
                  ...this.form,
                  ...this.form.selectRow,
                };
                this.saveInsert(isSubmit);
                this.$emit('success');
                this.closeDialog();
              });
            } else {
              this.form = {
                ...this.form,
                ...this.form.selectRow,
              };
              this.saveInsert(isSubmit);
              this.$emit('success');
              this.closeDialog();
            }
          });
        }
      });

      // });
    },
    // 保存新增
    saveInsert: function (isSubmit) {
      this.form.isSubmit = isSubmit;
      this.$postJSON(apis.feedbackApply, this.form).then((res) => {
        // 提交审批
        if (isSubmit) {
          this.form.changeId = res.data;
          this.$postJSON(`${apis.apsApproveApprovalApproveStart}/feed_back/${this.form.changeId}`, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.$emit('success');
          });
        } else {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.feedBack_add_dialog {
  .el-col {
    line-height: 34px;
  }
  .title {
    color: #0d9ae0;
    font-weight: bold;
    line-height: 16px;
    margin-top: 24px;
  }
  .base-item {
    font-size: 12px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;

    .row {
      overflow: hidden;
      .col {
        float: left;
        width: 25%;
        margin-top: 24px;
        &.col-12 {
          width: 50%;
        }
        &.long {
          width: 100%;
        }
        .key {
          color: #98a6ad;
          line-height: 16px;
        }
        .val {
          margin-top: 8px;
          font-weight: bold;
          color: #495057;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
